export default {
    backgroundColor: "#cee4e5"
};
